<template>
    <div>
   <v-container fluid grid-list-xl py-0>
        <section-tooltip title="Ticket Requests"></section-tooltip>
        <app-card
            customClasses="mb-30 inherit-overflow">
            <dx-data-grid
                ref="ticketRequestTable"
                :data-source="preparedRequests"
                :allow-column-reordering="false"
                :headerFilter="{ visible:true }"
                :row-alternation-enabled="true"
                :show-column-lines="true"
                :allow-column-resizing="true"
                :column-auto-width="true"
                :show-borders="true"
                :sorting="{ mode: 'single' }"
                :default-sort-order="'desc'"
                :height="'1000px'"
                :responsive="true"
                @cell-click="onCellClick"
                :selection="{ mode: 'single' }"
                :paging="false">
                <dx-column 
                    data-field="status" 
                    caption="Status" 
                    data-type="number" 
                    alignment="left" 
                    width="110"
                    :calculate-cell-value="calculateStatus"/>
                <dx-column 
                    data-field="date_request" 
                    caption="Date" 
                    data-type="date"
                    format="dd.MM.yyyy"
                    :sort-order="'desc'"
                    :sort-index="0"
                    width="140"/>
                <dx-column data-field="partner" caption="Partner" data-type="string" alignment="left" width="250"/>
                <dx-column data-field="event" caption="Event" data-type="string" alignment="left" width="400"/>
                <dx-column data-field="email" caption="E-Mail" data-type="string" alignment="left" width="300"/>
                <dx-column data-field="amount" caption="#" data-type="string" alignment="center" :allow-filtering="false" width="80"/>
                <dx-column data-field="note" caption="Note" data-type="string" :allow-filtering="false" alignment="left" />
                <dx-filter-row :visible="true"></dx-filter-row>
            </dx-data-grid>
        </app-card>
   </v-container>
   <waiting-list-detail-view 
            :request="selectedOrder || {}" 
            :isVisible="selectedOrder !== null"
            @close="onOrderDetailsClose"></waiting-list-detail-view>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Enumerable from 'linq'
import WaitingListDetailView from './WaitingListDetailsView'

export default {
    components: {
        WaitingListDetailView
    },
    data() {
        return {
            headers: [
                {
                    text: 'Status',
                    value: "status",
                    align: 'left',
                },
                {
                    text: 'Date',
                    value: "date_request",
                    align: 'left',
                },
                {
                    text: 'Partner',
                    value: "partner",
                    align: 'left',
                },
                {
                    text: 'Event',
                    value: "event",
                    align: 'left',
                },
                {
                    text: 'Email',
                    value: "email",
                    align: 'left',
                },
                {
                    text: 'Requested Tickets',
                    value: "amount",
                    align: 'left',
                },
                {
                    text: 'Note',
                    value: 'note',
                    align: 'left',
                }
            ],
            eventIdNameMap: {},
            preparedData: [],
            event: [],
            eventFilter: '',
            selectedOrder: null,
        }
    },
    computed: {
        ...mapGetters([
            'guestDetailEvents',
            'requestedTickets',
            'user'
        ]),
        eventsRequested: function () {
            if (this.requestedTickets.length) {
                const result = Enumerable.from(this.requestedTickets)
                    .groupBy(`{Label: $.FK_Event}`, null, (key, g) => {
                        return {
                            FK_Event: key.Label,
                        }
                    }, '$.Label')
                    .select('$.FK_Event')
                    .toArray()
                this.event = result[0]
                return result
            } else {
                return []
            }
        },
        filteredEvents() {
            if (!this.eventFilter) return this.preparedData;

            return this.preparedData.filter((item) => {
                return (item.FK_Event === this.eventFilter);
            });
        },
        preparedRequests() {
            const result = this.requestedTickets.map(ticket => ({
                ...ticket,
                event: this.eventIdNameMap[ticket.FK_Event],
                date_request: this.parseDate(ticket.date_request)
            }));
            return result;
        }
    },
    methods: {
        back() {
            this.$router.push({ name: 'waitinglist.events' })
        },
        onCellClick(e) {
            const orderData = {...e.data};
            if (!orderData.status) {
                orderData.status = 'Open';
            }
            this.selectedOrder = orderData;
        },
        onOrderDetailsClose() {
            this.selectedOrder = null
        },
        calculateStatus(rowData) {
            return rowData.status || 'Open';
        },
        parseDate(dateStr) {
            if (!dateStr) return null;
            
            // Entferne eventuelle Zeitangaben
            dateStr = dateStr.toString().split(' ')[0];
            
            // Ersetze alle Trennzeichen durch einen Punkt
            const normalizedDate = dateStr.replace(/[-\/\.]/g, '.');
            const parts = normalizedDate.split('.');
            
            if (parts.length === 3) {
                let year, month, day;
                
                // Prüfe auf YYYY-MM-DD Format
                if (parts[0].length === 4) {
                    year = parseInt(parts[0]);
                    month = parseInt(parts[1]) - 1; // JavaScript Monate sind 0-basiert
                    day = parseInt(parts[2]);
                } else {
                    // Gehe von DD.MM.YYYY Format aus
                    day = parseInt(parts[0]);
                    month = parseInt(parts[1]) - 1;
                    year = parseInt(parts[2]);
                }
                
                // Erstelle ein valides Date-Objekt
                const date = new Date(year, month, day);
                
                // Prüfe ob das Datum valide ist
                if (!isNaN(date.getTime())) {
                    return date;
                }
            }
            
            // Fallback: Versuche direktes Parsen
            const fallbackDate = new Date(dateStr);
            return !isNaN(fallbackDate.getTime()) ? fallbackDate : null;
        },
        formatDate(rowData) {
            // Diese Methode wird von DevExtreme für jede Zelle aufgerufen
            return this.parseDate(rowData.date_request);
        }
    },
    async created() {
        await this.$store.dispatch('getGuestDetailsEvents', { companyId: this.user.company.id, seasonId: this.season })
        await this.$store.dispatch('getTicketRequests')
    },
    beforeUpdate() {
        this.eventIdNameMap = this.guestDetailEvents.reduce(function (map, obj) {
            map[obj.eventId] = obj.eventName;
            return map;
        }, {});
    }
}
</script>

<style lang="scss">
.dx-popup-wrapper > .dx-overlay-content {
    width: 450px !important;
}
</style>